import { css } from '@linaria/core';
export const Root = {
    base: css `
		float: right;

		margin-right: 0;
		/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
		color: #fff;
		text-transform: none;

		background: none;

		svg {
			position: absolute;
			top: 0;
			left: -40%;

			width: 1rem;
			border-radius: 50%;

			background: rgb(var(--brand-dark-secondary));

			fill: rgb(var(--brand-text-secondary));

			transition: opacity 200ms var(--global-ease-out);

			@media (hover: hover) and (pointer: fine) {
				opacity: 0;
			}
		}
	`,
};
